<template>
  <div class="hab-checkbox" :class="className">
    <div
      class="checkbox-block"
      v-on:click="disabled ? undefined : checkboxChange()"
    >
      <div class="checkbox" :class="{ checked: isChecked }">
        <input type="checkbox" :checked="isChecked" :disabled="disabled" />
        <span></span>
      </div>
      <label v-if="label" class="name"
        >{{ label }}<span v-if="required"></span
      ></label>
      <slot></slot>
    </div>
    <span v-if="error" class="alert-input-error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onCheck"],
  data() {
    return {
      isChecked: false,
    };
  },
  methods: {
    checkboxChange() {
      this.isChecked = !this.isChecked;
      return this.$emit("onCheck", this.isChecked);
    },
  },
  mounted() {
    this.isChecked = this.checked;
  },
};
</script>

<style lang="scss" scoped>
.hab-checkbox {
  user-select: none;
  display: inline-block;
  position: relative;
  .checkbox-block {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .checkbox {
    position: relative;
    margin: 0;
    input {
      display: none;
      opacity: 0;
    }
    span {
      display: block;
      width: 16px;
      height: 16px;
      border: 2px solid #000;
      box-sizing: border-box;
      cursor: pointer;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        margin-left: -2px;
        top: 50%;
        margin-top: -5.5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        z-index: -999;
      }
    }
    &.checked {
      span {
        background-color: #1890ff;
        border-color: #1890ff;
        &::after {
          z-index: 1;
        }
      }
    }
  }
  .name {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    cursor: pointer;
  }
}
</style>
